import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { listAdminExports } from "../../api/exports";
import ExportsTable from "../../components/Exports/ExportsTable";
import { useErrorHandler } from "../../hooks/Error/useErrorHandler";
import { setLoading } from "../../store/UI";
import { ExportRow } from "../../types/model/export/ExportRow";

const AdminExports = () => {
  const dispatch = useDispatch();
  const handleError = useErrorHandler();

  const [exports, setExports] = React.useState<ExportRow[]>([]);

  const refreshData = async () => {
    dispatch(setLoading(true));

    try {
      const response = await listAdminExports();
      setExports(response);
    } catch (error) {
      handleError(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    refreshData();
  }, []);

  return (
    <ExportsTable
      tableData={exports}
      onRequestRefresh={refreshData}
      mode="admin"
    />
  );
};

export default AdminExports;